import React from 'react'
import "./FormikInputsPosition.scss";

function FormikInputsPosition({children, title, position}) {
  //classes per position
  const positionClass = {
    1: "formikInputsPosition-1",
    2: "formikInputsPosition-2",
    3: "formikInputsPosition-3",
    4: "formikInputsPosition-4",
    5: "formikInputsPosition-5",
    6: "formikInputsPosition-6",
    7: "formikInputsPosition-7",
  };

  return (
    <div className={positionClass[position]}>
      <div className="formikInputsPosition-span-container all-width-height">
        <span className="body-14">{title}</span>
      </div>
      <div className="formikInputsPosition-input-container all-width-height">
        {children}
      </div>
    </div>
  );
}

export default FormikInputsPosition
